import Box from "@mui/material/Box";
import { Divider, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const ReturnPolicy = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <HeaderText>ნივთის დაბრუნება</HeaderText>
      <CustomDivider />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>დისტანციურად შეძენილი საქონლის უკან დაბრუნების პირობები</b>
          <span>
            მომხმარებლის მიერ ნივთის დისტანციური ხელშეკრულების ან სარეწის გარეთ
            დადებული ხელშეკრულების საფუძველზე შეძენისას, მომხმარებელს უფლება
            აქვს, ყოველგვარი საფუძვლის მითითების გარეშე თქვას უარი დისტანციურ
            ხელშეკრულებაზე ან/და სარეწის გარეთ დადებულ ხელშეკრულებაზე 14
            კალენდარული დღის განმავლობაში. ასეთ შემთხვევაში, მომხმარებელი
            ვალდებულია საკუთარი ხარჯით (ნივთის ტრანსპორტირება, დემონტაჟი და
            სხვა) დაუბრუნოს ნივთი "მობაილ სთორის", თუ ნივთის ღირებულება
            აღემატება 30 ლარს
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>
            დისტანციურ ხელშეკრულებაზე ან/და სარეწის გარეთ დადებულ ხელშეკრულებაზე
            უარის თქმის უფლება
          </b>
          <span>
            ამ საქართველოს კანონმდებლობისა და ამ პოლიტიკის მე-5 მუხლით დადგენილი
            გამონაკლისების გარდა, მომხმარებელს უფლება აქვს, ყოველგვარი საფუძვლის
            მითითების გარეშე თქვას უარი დისტანციურ ხელშეკრულებაზე ან/და სარეწის
            გარეთ დადებულ ხელშეკრულებაზე 14 კალენდარული დღის განმავლობაში. ეს
            ვადა აითვლება: ა) მომსახურების ხელშეკრულების შემთხვევაში −
            ხელშეკრულების დადებიდან; ბ) ნასყიდობის ხელშეკრულების შემთხვევაში −
            მომხმარებლის ან მის მიერ განსაზღვრული მესამე პირის მიერ (გარდა
            გადამზიდავისა) საქონლის მფლობელობაში მიღებიდან; გ) მომხმარებლის მიერ
            საქონლის ნაწილ-ნაწილ შეკვეთის შემთხვევაში − მომხმარებლის ან მის მიერ
            განსაზღვრული მესამე პირის მიერ (გარდა გადამზიდავისა) ბოლო ნივთის
            მფლობელობაში მიღებიდან; დ) საქონლის რეგულარულად (განსაზღვრული
            პერიოდულობით) მიწოდების ხელშეკრულების შემთხვევაში − მომხმარებლის ან
            მის მიერ განსაზღვრული მესამე პირის მიერ (გარდა გადამზიდავისა) ნივთის
            მფლობელობაში პირველად მიღებიდან. მომხმარებლის მიერ ხელშეკრულებაზე
            უარის თქმის შემთხვევაში მას არ დაეკისრება არანაირი ხარჯის (მათ
            შორის, მიწოდების ხარჯის) გაწევა, გარდა იმ შემთხვევისა, როდესაც
            მომხმარებელმა "მობაილ სთორის" მიერ შეთავაზებული სტანდარტული
            მიწოდების მომსახურებაზე უფრო ძვირი მიწოდების მომსახურება აირჩია ან
            საქონლის ფასი შემცირდა ისეთი სარგებლობის შედეგად, რომელიც
            დაკავშირებული არ არის საქონლის ბუნების, მახასიათებლებისა და
            ფუნქციონირების დადგენასთან. საქონლის ფასის შემცირების შედეგად
            წარმოშობილი სხვაობის დაფარვის ვალდებულება მომხმარებელს არ
            დაეკისრება, თუ "მობაილ სთორმა" მას კანონით გათვალისწინებული
            ხელშეკრულებაზე უარის თქმის უფლების შესახებ სრული ინფორმაცია არ
            მიაწოდა. მომხმარებლის მიერ დისტანციურ ხელშეკრულებაზე უარის თქმა
            ავტომატურად იწვევს დაკავშირებული ხელშეკრულებიდან მის გასვლას და
            პირვანდელი მდგომარეობის აღდგენას. მომხმარებელი ვალდებულია "მობაილ
            სთორს" ამ მუხლის პირველი პუნქტით დადგენილ ვადაში გაუგზავნოს
            შევსებული ფორმა (დანართი 1) ან სხვა ცალსახა მტკიცებულება, რომელიც
            ასახავს მომხმარებლის გადაწყვეტილებას საქონლის დაბრუნების შესახებ. ამ
            მუხლით გათვალისწინებული ხელშეკრულებაზე უარის თქმის უფლების დადგენილ
            ვადაში განხორციელების მტკიცების ტვირთი მომხმარებელს ეკისრება.
            მომხმარებელს შეუძლია ხელშეკრულებაზე უარის თქმის უფლება განახორციელოს
            ამ მუხლის პირველი პუნქტით დადგენილ ვადაში, თუ მან ხელშეკრულებაზე
            უარის თქმის შესახებ შეტყობინება "მობაილ სთორს" აღნიშნული ვადის
            ამოწურვამდე გაუგზავნა. იმის მტკიცების ტვირთი, რომ ხელშეკრულებაზე
            უარის თქმის უფლება ამ მუხლის შესაბამისად განხორციელდა, მომხმარებელს
            ეკისრება. თუ "მობაილ სთორი" მომხმარებელს არ მიაწვდის ინფორმაციას ამ
            კანონით გათვალისწინებული საქონლის ან მომსახურების დაბრუნების უფლების
            შესახებ, აღნიშნული საქონლის ან მომსახურების დაბრუნება შესაძლებელია
            ამ მუხლის პირველი პუნქტით დადგენილი ვადის გასვლიდან 12 თვის
            განმავლობაში. თუ "მობაილ სთორმა" მომხმარებელს ამ მუხლის პირველი
            პუნქტით დადგენილი ვადის ათვლის მომენტიდან 12 თვის ვადაში მიაწოდა
            ინფორმაცია ხელშეკრულებაზე უარის თქმის უფლების შესახებ, საქონლის ან
            მომსახურების დაბრუნების 7-დღიანი ვადა აღნიშნული ინფორმაციის
            მიღებიდან აითვლება.
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b>
            ყოველგვარი საფუძვლის მითითების გარეშე ხელშეკრულებაზე უარის თქმასთან
            დაკავშირებული გამონაკლისები
          </b>
          <span>
            მომხმარებელს არ აქვს უფლება, უარი თქვას ხელშეკრულებაზე, თუ: ა)
            "მობაილ სთორიმ" ხელშეკრულებით გათვალისწინებული მომსახურება სრულად
            გასწია, მან მომსახურების გაწევა მომხმარებლის წინასწარი თანხმობით
            დაიწყო და მომხმარებელმა იცოდა, რომ მომსახურების სრულად მიღების
            შემთხვევაში დაკარგავდა ხელშეკრულებაზე უარის თქმის უფლებას; ბ)
            ხელშეკრულებით გათვალისწინებულია, რომ მიწოდებული საქონლის ან
            მომსახურების ფასი დამოკიდებულია ფინანსურ ბაზარზე არსებულ ცვლილებაზე,
            რომელსაც "მობაილ სთორი" ვერ აკონტროლებს და რომელიც ხელშეკრულებაზე
            უარის თქმის უფლების განხორციელებისთვის ამ კანონით დადგენილ ვადაში
            წარმოიშვა; გ) მიწოდებული საქონელი ან მომსახურება მომხმარებლის
            ინდივიდუალური შეკვეთით არის დამზადებული ან აშკარად მის პირად
            საჭიროებებზეა მორგებული; დ) მიწოდებული საქონელი მალფუჭებადია ან მას
            მოკლე ვარგისობის ვადა აქვს; ე) მას მიეწოდა ჰერმეტულად დაცული
            საქონელი, მისი ჰერმეტულობა მიწოდების შემდეგ დაირღვა და, ამდენად,
            საქონლის დაბრუნება შეუძლებელია ჯანმრთელობის ან ჰიგიენური ნორმების
            დაცვის გამო; ვ) მიწოდებული საქონელი მიწოდების დროს, მისი
            მახასიათებლებიდან გამომდინარე, განუყოფლად შეერწყა სხვა საქონელს; ზ)
            მიწოდებულ იქნა დალუქული აუდიო- ან ვიდეოჩანაწერი ან პროგრამული
            უზრუნველყოფა და მისი ლუქი მიწოდების შემდეგ დაირღვა; თ) მას ციფრული
            შინაარსი მიეწოდა არამყარი მატარებლით, ხელშეკრულების შესრულება
            მომხმარებლის წინასწარი თანხმობით დაიწყო და მომხმარებელმა იცოდა, რომ
            ამით დაკარგავდა ხელშეკრულებაზე უარის თქმის უფლებას;
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <b> ხელშეკრულებაზე უარის თქმის შედეგები</b>
          <span>
            ხელშეკრულებაზე უარის თქმის შედეგად ქარწყლდება მხარეების მიერ
            დისტანციური ხელშეკრულებით ან სარეწის გარეთ დადებული ხელშეკრულებით
            ნაკისრი ვალდებულებები, ხოლო ის, რაც მხარეებმა მისი შესრულებით
            მიიღეს, მათ უბრუნდებათ. 2. ხელშეკრულებაზე უარის თქმის შემთხვევაში
            "მობაილ სთორი" ვალდებულია: ა) მომხმარებელს გადახდილი თანხა, აგრეთვე
            არსებობის შემთხვევაში − მიწოდების ხარჯის ასანაზღაურებლად გადახდილი
            თანხა დაუბრუნოს სრულად, გაჭიანურების გარეშე, ხელშეკრულებაზე უარის
            თქმის შესახებ შეტყობინების მიღებიდან არაუგვიანეს 14 კალენდარული
            დღისა. "მობაილ სთორი" ვალდებული არ არის, მომხმარებელს დაუბრუნოს იმ
            დამატებითი ხარჯის ასანაზღაურებლად გადახდილი თანხა, რომელიც
            დაკავშირებულია მომხმარებლის მიერ არასტანდარტული ან "მობაილ სთორი"
            მიერ შეთავაზებული მიწოდების მომსახურებაზე უფრო ძვირი მიწოდების
            მომსახურების არჩევასთან; ბ) თანხა აანაზღაუროს გადახდის იმავე
            საშუალებებით, რომლებიც მომხმარებელმა გამოიყენა, გარდა იმ
            შემთხვევისა, როდესაც მომხმარებელი გადახდის სხვა საშუალების
            გამოყენებაზე თანხმობას განაცხადებს და მას დამატებითი ხარჯი არ
            წარმოეშობა. ნასყიდობის ხელშეკრულებაზე უარის თქმის შემთხვევაში
            "მობაილ სთორს" უფლება აქვს, უარი თქვას თანხის დაბრუნებაზე მანამ,
            სანამ საქონელს არ დაიბრუნებს ან მომხმარებლისგან არ მიიღებს საქონლის
            გაგზავნის დამადასტურებელ დოკუმენტს, იმის მიხედვით, რომელიც უფრო ადრე
            განხორციელდება, გარდა იმ შემთხვევისა, როდესაც "მობაილ სთორმა" თავად
            იკისრა საქონლის უკან წაღება. ხელშეკრულებაზე უარის თქმის შემთხვევაში
            მომხმარებელი ვალდებულია: ა) "მობაილ სთორს" ან მის მიერ განსაზღვრულ
            მესამე პირს დაუბრუნოს საქონელი ხელშეკრულებაზე უარის თქმის შესახებ
            შეტყობინების გაგზავნის შემდეგ დაუყოვნებლივ, მაგრამ არაუგვიანეს 7
            კალენდარული დღისა, გარდა იმ შემთხვევისა, როდესაც "მობაილ სთორმა"
            თავად იკისრა საქონლის უკან წაღება; ბ) გასწიოს მხოლოდ საქონლის
            დაბრუნებასთან დაკავშირებული პირდაპირი (უშუალო) ხარჯი, გარდა იმ
            შემთხვევისა, როდესაც "მობაილ სთორმა" თავად იკისრა ამ ხარჯის გაწევა
            ან მომხმარებელს არ მიაწოდა ინფორმაცია იმის შესახებ, რომ საქონლის
            დაბრუნების შემთხვევაში ეს ხარჯი წარმოიშობოდა. სარეწის გარეთ დადებული
            ხელშეკრულების შემთხვევაში, როდესაც საქონელი მომხმარებელს სახლში
            მიეწოდება, "მობაილ სთორი" ვალდებულია საქონელი საკუთარი ხარჯით წაიღოს
            უკან, თუ, საქონლის ბუნებიდან გამომდინარე, მისი ფოსტით გაგზავნა
            შეუძლებელია.
          </span>
        </div>
      </div>
    </Box>
  );
};

export default ReturnPolicy;
